module.exports = __webpack_public_path__ + "static/media/lineb.40cba8ec.jpg";